module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"available":"В наличии","transit":"В пути","remote":"Производство","preorder":"Под заказ","to_cart":"В корзину","stock_pcs":"Склад, шт.","no":"Нет","request_price":"Запросить цену"},"en":{"available":"In stock","transit":"In transit","remote":"Remote","preorder":"Preorder","to_cart":"Add to cart","stock_pcs":"Stock, pcs.","no":"No","request_price":"Request a price"}}')
  delete Component.options._Ctor
}
